import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfigDev, msalConfigProd } from "./authConfig";

let msalInstance;
if(process.env.NODE_ENV === 'production') {
  msalInstance = new PublicClientApplication(msalConfigProd);
}
else {
  msalInstance = new PublicClientApplication(msalConfigDev);
}

ReactDOM.render(
  <React.StrictMode>
     <MsalProvider instance={msalInstance}>
       <App />
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
